import moment from 'moment';
import { useEffect, useState } from 'react';
import ImageViewer from 'react-simple-image-viewer';
import ProviderCommonApi from '../../../../../API/provider/common-api';
import chzn_icon from '../../../../../assets/media/chzn.png';
import chz_active_icon from '../../../../../assets/media/chzn_atcive.png';
import { Column, Row } from '../../../../../components/Basic/Blocks';
import { Button, CheckButton, FileDropzone } from '../../../../../components/Basic/Buttons';
import { Icon } from '../../../../../components/Basic/Elements';
import { EditInput, Input } from '../../../../../components/Basic/Inputs';
import { TableCell, TableLine } from '../../../../../components/Basic/Table';
import { Text, TextGrey } from '../../../../../components/Basic/WrapsStyle';
import MarketsPairs from '../../../../../components/Common/Elements/MarketsPairs';
import BarcodesBlock from '../../../../../components/Common/Input/Barcodes';
import ProviderList from '../../../../../components/Common/Input/ProviderList';
import ProviderEditInput from '../../../../../components/Providers/Blocks/ProductsTable/EditInput';
import ProductUnitSelect from '../../../../../components/Providers/Inputs/ProductUnitSelect';
import ContentStatus from '../../../../../components/Providers/WrapsStyle/ProductContentStatus';
import { TYPE_BUTTONS } from '../../../../../constans';
import { formFullDate, formNumQuantity } from '../../../../../utils';
import AvitoCategorySelect from '../../AvitoCategorySelect';
import OzonCategorySelect from '../../OzonCategorySelect';
import WbCategorySelect from '../../WbCategorySelect';
import styles from '../styles.module.scss';

const ContentWorkLine = ({
  card = {},
  width = width,
  role,
  MODES,
  contentMode,
  isAdmin = true,
  product = {},
  productsSelect = {},
  changeProductSelect = (_) => _,
  onChange = (_) => _,
  onChangeImages = (_) => _,
  market,
  providerId,
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [images, setImages] = useState([]);

  const openImageViewer = () => {
    setIsViewerOpen(true);
  };

  const closeImageViewer = () => {
    setIsViewerOpen(false);
  };

  const onChangeCard = (key, value, action) => {
    onChange(card.sku, key, value, action);
  };
  const wb_kvant = formNumQuantity(card.content_data.quantity, card.content_data.unit, true);
  const ozon_kvant = formNumQuantity(card.content_data.quantity, card.content_data.unit, true);
  const avito_kvant = formNumQuantity(card.content_data.quantity, card.content_data.unit, true);

  const bwhite_kvant = formNumQuantity(card.content_data.quantity, card.content_data.unit, true);

  const wb_name = `${card.wb_meta?.name}${wb_kvant}`;
  const ozon_name = `${card.ozon_meta?.name}${ozon_kvant}`;
  const avito_name = `${card.avito_meta?.name}${avito_kvant}`;
  const bwhite_name = `${card.bwhite_meta?.name}${bwhite_kvant}`;

  useEffect(() => {
    let imgs =
      card.images.local?.length > 0
        ? card.images.local
        : card.images.foreign?.length > 0
          ? card.images.foreign
          : ['https://api.samsonopt.ru/goods/110983/b2fadb432e3ec30f0ccd03c3b2f624e1_x.jpg'];

    setImages(imgs);
  }, [card.images]);

  return (
    <>
      <TableLine key={card.sku} select={productsSelect[card.sku]} styles={styles.table_line}>
        {card.is_exclusive && <div className={styles.product_status} />}
        <TableCell width={width[10]}>
          <CheckButton checked={productsSelect[card.sku]} onSelect={() => changeProductSelect(card.sku)} />
        </TableCell>
        <TableCell>
          <Row spaceBetween>
            <div className={styles.wrapper}>
              {images.length > 0 && (
                <img onClick={() => openImageViewer(images)} className={styles.preview} src={images[0]} alt="preview" />
              )}
            </div>
          </Row>
        </TableCell>
        {/* {card.provider_id === 11 && (
          <TableCell width={'180px'}>
            <Button style={{ marginBottom: '5px', height: '25px' }} type={TYPE_BUTTONS.GREEN}
              onClick={async () => {
                await ProviderCommonApi.downloadImages({ data: { sku: card.sku } })
              }}
            >
              Скачать фото
            </Button >
            <FileDropzone
              onClickLoad={(files) =>
                onChangeImages({ data: { sku: card.sku, field: 'images_local', files, fileNames: files.map(f => f.name) }, options: { uploadFiles: true } })
              }
            />
          </TableCell>
        )} */}
        <TableCell width={width[1]} center>
          <Column>
            {card.url?.length > 0 ? (
              <a href={card.url} target="_blank" className={styles.link_artnumber} rel="noreferrer">
                {card.artnumber}
              </a>
            ) : (
              card.artnumber
            )}
            <Row style={{ color: 'red', fontWeight: '600' }}>{card.isKgt && 'КГТ'}</Row>
          </Column>
        </TableCell>
        <TableCell width={width[1]}>{card.brand}</TableCell>
        <TableCell width={width[2]} style={{ flexWrap: 'nowrap' }}>
          <Column>
            <p className={styles.name_text}>{card.name}</p>
            {/*<a href={TO_PROVIDER_PRODUCT( card.sku)} target={'_blank'} className={styles.link}>
              <p className={styles.name_text}>{card.name}</p>
            </a>*/}
            <TextGrey fontSize={12}>{card.category}</TextGrey>
          </Column>
        </TableCell>
        {contentMode === MODES[0] && role !== 'content' && (
          <>
            <TableCell width={width[3]} center>
              <Input value={card.remains} center />
            </TableCell>
            <TableCell width={width[4]} center>
              <Input value={card.purchase} center />
            </TableCell>
            <TableCell width={width[4]} center>
              {card.min_opt} / {card.min_kor}
            </TableCell>
            <TableCell width={width[4]} center>
              {card.ban_not_multiple ? 'Да' : 'Нет'}
            </TableCell>
            <TableCell width={width[7]} center>
              <ProviderList selectProviderId={card.provider_id} disabled={true} />
            </TableCell>
            <TableCell width={width[13]} center>
              <BarcodesBlock barcodes={card.barcodes} />
            </TableCell>
          </>
        )}

        {contentMode === MODES[1] && (
          <>
            <TableCell width={width[4]} center>
              <Text fontWeight={700} fontSize={16}>
                {providerId === -1 ? card.content_data.quantity_sklad : card.content_data.quantity}
              </Text>
            </TableCell>
            <TableCell width={width[12]} center>
              <ContentStatus contentStatus={card.content_data.statuses[market.toLowerCase()]?.status} />
            </TableCell>
            <TableCell width={width[9]} center>
              <Row>
                <Input
                  value={card.content_data.sizes.width}
                  center
                  onBlur={(v) => onChangeCard('width', v)}
                  width={'50px'}
                  fontWeight={600}
                />
                <Text> x </Text>
                <Input
                  value={card.content_data.sizes.depth}
                  center
                  onBlur={(v) => onChangeCard('depth', v)}
                  width={'50px'}
                  fontWeight={600}
                />
                <Text> x </Text>
                <Input
                  value={card.content_data.sizes.height}
                  center
                  onBlur={(v) => onChangeCard('height', v)}
                  width={'50px'}
                  fontWeight={600}
                />
              </Row>
            </TableCell>
            <TableCell width={width[9]} center>
              <Text fontSize={16}>
                {role !== 'content' ? (
                  <ProviderEditInput
                    name={card.content_data.min_volume}
                    onChange={(v) => onChangeCard('min_volume', v)}
                    width={'30px'}
                    disabled={role === 'content'}
                  />
                ) : (
                  card.content_data.min_volume
                )}
                {` л. < `}
                <span
                  style={
                    card.content_data.volume >= card.content_data.min_volume &&
                      card.content_data.volume <= card.content_data.max_volume
                      ? { color: 'green', fontWeight: 600 }
                      : { color: 'red', fontWeight: 600 }
                  }
                >
                  {card.content_data.volume}
                </span>
                {` л.  < `}
                {role !== 'content' ? (
                  <ProviderEditInput
                    name={card.content_data.max_volume}
                    onChange={(v) => onChangeCard('max_volume', v)}
                    width={'30px'}
                    disabled={role === 'content'}
                  />
                ) : (
                  card.content_data.max_volume
                )}
                {` л.`}
              </Text>
            </TableCell>
            <TableCell width={width[4]} center>
              <Input
                value={card.content_data.weight}
                center
                onBlur={(v) => onChangeCard('weight', v)}
                width={'70px'}
                fontWeight={600}
              />
            </TableCell>
            <TableCell width={width[9]} center>
              <Text fontSize={16}>
                {role !== 'content' ? (
                  <ProviderEditInput
                    name={card.content_data.min_weight}
                    onChange={(v) => onChangeCard('min_weight', v)}
                    width={'30px'}
                  />
                ) : (
                  card.content_data.min_weight
                )}
                {` кг. < `}{' '}
                <span
                  style={
                    card.content_data.weight >= card.content_data.min_weight &&
                      card.content_data.weight <= card.content_data.max_weight
                      ? { color: 'green', fontWeight: 600 }
                      : { color: 'red', fontWeight: 600 }
                  }
                >
                  {card.content_data.weight}{' '}
                </span>{' '}
                кг. {` < `}{' '}
                {role !== 'content' ? (
                  <ProviderEditInput
                    name={card.content_data.max_weight}
                    onChange={(v) => onChangeCard('max_weight', v)}
                    width={'30px'}
                  />
                ) : (
                  card.content_data.max_weight
                )}
                {` кг.`}
              </Text>
            </TableCell>
            <TableCell width={width[11]} center>
              <Input value={card.term} center onBlur={(v) => onChangeCard('term', v)} width={'100px'} />
            </TableCell>
            <TableCell width={width[12]} center>
              <ProductUnitSelect
                unit={card.content_data?.unit}
                onSelect={(v) => onChangeCard('unit', v)}
                width={'140px'}
              />
            </TableCell>
          </>
        )}

        {contentMode === MODES[2] && (
          <>
            <TableCell width={width[2]}>
              <Column>
                <Row style={{ marginBottom: '4px', display: 'inline-block', minHeight: '30px' }}>
                  <EditInput
                    name={card.wb_meta.name || ''}
                    onChange={(v) => onChangeCard('wb_name', v)}
                    width={'300px'}
                    styleText={wb_name.length > 60 ? { color: 'red', fontWeight: 500 } : {}}
                    wb_kvant={wb_kvant}
                  />
                </Row>

                <TextGrey fontSize={12}>
                  {card.wb_meta.name.length} + {wb_kvant.length} = {wb_name.length}
                </TextGrey>
              </Column>
            </TableCell>
            <TableCell width={width[14]} center>
              <WbCategorySelect category={card.wb_meta.category} onChange={(v) => onChangeCard('wb_category', v)} />
            </TableCell>
            <TableCell width={width[12]} center>
              <Input
                value={card.short_name}
                onBlur={(v) => onChangeCard('short_name', v)}
                width={'170px'}
                maxLength={28}
                error={card.label?.length === 0 && card.quantity_content > 1 ? 'Не заполнен заголовок' : ''}
              />
            </TableCell>
            <TableCell width={width[12]} center>
              <ProductUnitSelect
                unit={card.content_data?.unit}
                onSelect={(v) => onChangeCard('unit', v)}
                width={'140px'}
              />
            </TableCell>
            <TableCell width={width[12]} center>
              <ContentStatus contentStatus={card.content_data.statuses[market.toLowerCase()]?.status} />
            </TableCell>
          </>
        )}

        {contentMode === MODES[5] && (
          <>
            <TableCell width={width[2]}>
              <Column>
                <Row style={{ marginBottom: '4px', display: 'inline-block', minHeight: '30px' }}>
                  <EditInput
                    name={card.bwhite_meta?.name || ''}
                    onChange={(v) => onChangeCard('bwhite_name', v)}
                    width={'300px'}
                    styleText={bwhite_name.length > 300 ? { color: 'red', fontWeight: 500 } : {}}
                    wb_kvant={bwhite_kvant}
                  />
                </Row>

                <TextGrey fontSize={12}>
                  {card.bwhite_meta?.name.length} + {bwhite_kvant.length} = {bwhite_name.length}
                </TextGrey>
              </Column>
            </TableCell>
            <TableCell width={width[14]} center>
              <WbCategorySelect
                category={card.bwhite_meta.category}
                onChange={(v) => onChangeCard('bwhite_category', v)}
                label="Категория b-white"
              />
            </TableCell>
            <TableCell width={width[12]} center>
              <ProductUnitSelect
                unit={card.content_data?.unit}
                onSelect={(v) => onChangeCard('unit', v)}
                width={'140px'}
              />
            </TableCell>
            <TableCell width={width[12]} center>
              <ContentStatus contentStatus={card.content_data.statuses[market.toLowerCase()]?.status} />
            </TableCell>
          </>
        )}

        {contentMode === MODES[3] && (
          <>
            <TableCell width={width[2]}>
              <Column>
                <Row style={{ marginBottom: '4px', display: 'inline-block', minHeight: '30px' }}>
                  <EditInput
                    name={card.ozon_meta.name || ''}
                    onChange={(v) => onChangeCard('ozon_name', v)}
                    width={'300px'}
                    maxLength={200}
                    wb_kvant={ozon_kvant}
                  />
                </Row>

                <TextGrey fontSize={12}>
                  {card.ozon_meta.name.length} + {ozon_kvant.length} = {ozon_name.length}
                </TextGrey>
              </Column>
            </TableCell>
            <TableCell width={width[14]} center>
              <OzonCategorySelect
                category={card.ozon_meta.category}
                onChange={(v) => onChangeCard('ozon_category', v)}
              />
            </TableCell>
            <TableCell width={width[12]} center>
              <Input
                value={card.short_name}
                onBlur={(v) => onChangeCard('short_name', v)}
                width={'170px'}
                maxLength={28}
                error={card.label?.length === 0 && card.quantity_content > 1 ? 'Не заполнен заголовок' : ''}
              />
            </TableCell>
            <TableCell width={width[12]} center>
              <ProductUnitSelect
                unit={card.content_data?.unit}
                onSelect={(v) => onChangeCard('unit', v)}
                width={'140px'}
              />
            </TableCell>
            <TableCell width={width[12]} center>
              <ContentStatus contentStatus={card.content_data.statuses[market.toLowerCase()]?.status} />
            </TableCell>
          </>
        )}

        {contentMode === MODES[4] && (
          <>
            <TableCell width={width[2]}>
              <Column>
                <Row style={{ marginBottom: '4px', display: 'inline-block', minHeight: '30px' }}>
                  <EditInput
                    name={card.avito_meta.name || ''}
                    onChange={(v) => onChangeCard('avito_name', v)}
                    width={'300px'}
                    styleText={avito_name.length > 100 ? { color: 'red', fontWeight: 500 } : {}}
                    maxLength={100 - (avito_kvant.length || 1)}
                    wb_kvant={avito_kvant}
                  />
                </Row>

                <TextGrey fontSize={12}>
                  {card.avito_meta.name?.length} + {avito_kvant.length} = {avito_name.length}
                </TextGrey>
              </Column>
            </TableCell>
            <TableCell width={width[2]} center>
              <AvitoCategorySelect
                category={card.avito_meta.category}
                onChange={(v) => onChangeCard('avito_category', v)}
              />
            </TableCell>
            <TableCell width={width[12]} center>
              <Input
                value={card.short_name}
                onBlur={(v) => onChangeCard('short_name', v)}
                width={'170px'}
                maxLength={28}
                error={card.label?.length === 0 && card.quantity_content > 1 ? 'Не заполнен заголовок' : ''}
              />
            </TableCell>
            <TableCell width={width[12]} center>
              <ProductUnitSelect
                unit={card.content_data?.unit}
                onSelect={(v) => onChangeCard('unit', v)}
                width={'140px'}
              />
            </TableCell>
            <TableCell width={width[12]} center>
              <ContentStatus contentStatus={card.content_data.statuses[market.toLowerCase()]?.status} />
            </TableCell>
          </>
        )}

        <TableCell width={width[5]} center>
          {card.content_data.managers && card.content_data.managers[market.toLowerCase()]}
          {/*  {market === 'Ozon' ? card.content_data.managers?.ozon : card.content_data.managers?.wb} */}
        </TableCell>
        <TableCell width={width[5]} center className={styles.cell_date}>
          {card.created_at ? (
            <>
              <Text>{formFullDate(card.created_at)}</Text>
              <TextGrey fontSize={12}> {moment(card.created_at).fromNow()}</TextGrey>
            </>
          ) : (
            '-'
          )}
        </TableCell>
        <TableCell width={width[5]} center className={styles.cell_date}>
          {card.updated_at ? (
            <>
              <Text>{formFullDate(card.updated_at)}</Text>
              <TextGrey fontSize={12}> {moment(card.updated_at).fromNow()}</TextGrey>
            </>
          ) : (
            '-'
          )}
        </TableCell>
        <TableCell width={width[3]} center>
          {card.days_after_update}
        </TableCell>
        {isAdmin && (
          <TableCell width={width[10]} fontSize="14px" center>
            <Button onClick={() => onChangeCard('is_chzn', !card.is_chzn)}>
              <Icon src={card.is_chzn ? chz_active_icon : chzn_icon} width={'40px'} />
            </Button>
          </TableCell>
        )}

        <TableCell width={width[8]} fontSize="14px">
          <MarketsPairs market={card.market} />
        </TableCell>
      </TableLine>
      {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
    </>
  );
};

export default ContentWorkLine;
